import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "children"],
    _excluded2 = ["children"];
import React, { useCallback } from 'react';
import Box from '../Box';
import styled, { withTheme } from 'styled-components';
import Text from '../Text';
import BasicPulldown from '../Pulldown';
import { focusOutlinePadding } from '../focus';
import { isFunction, noop } from '../utils';
export var FilterCategoriesContainer = styled(Box).withConfig({
  displayName: "SheetFilterMenu__FilterCategoriesContainer",
  componentId: "sc-snnim5-0"
})(["display:flex;align-items:center;background:", ";padding:10px ", ";justify-content:space-between;border-bottom:1px solid ", ";border-top:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.bg;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.menuList.paddingX;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['keyline'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors['keyline'];
});
export var FiltersCategory = withTheme(function (_ref5) {
  var theme = _ref5.theme,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    mr: "10px",
    color: "label",
    textStyle: theme.menuList.textStyle
  }, props), children);
});
export var FiltersPulldown = withTheme(function (_ref6) {
  var filters = _ref6.filters,
      value = _ref6.value,
      _ref6$onSelect = _ref6.onSelect,
      onSelect = _ref6$onSelect === void 0 ? noop : _ref6$onSelect;
  var onSelectCallback = useCallback(function (e) {
    if (isFunction(onSelect)) {
      onSelect(e.target.value);
    }
  }, [onSelect]);
  return /*#__PURE__*/React.createElement(BasicPulldown, {
    boxProps: {
      overflow: 'hidden',
      padding: focusOutlinePadding
    },
    value: value,
    onChange: onSelectCallback
  }, filters.map(function (filter) {
    return /*#__PURE__*/React.createElement("option", {
      key: filter.value,
      value: filter.value,
      disabled: filter.disabled,
      selected: filter.value === value
    }, filter.title);
  }));
});
export var FilterCategories = function FilterCategories(_ref7) {
  var filters = _ref7.filters,
      title = _ref7.title,
      selectedValue = _ref7.selectedValue,
      onSelect = _ref7.onSelect;
  return /*#__PURE__*/React.createElement(FilterCategoriesContainer, null, /*#__PURE__*/React.createElement(FiltersCategory, null, title), /*#__PURE__*/React.createElement(FiltersPulldown, {
    filters: filters,
    value: selectedValue,
    onSelect: onSelect
  }));
};
export var FiltersSheetTitle = function FiltersSheetTitle(_ref8) {
  var children = _ref8.children,
      props = _objectWithoutProperties(_ref8, _excluded2);

  return /*#__PURE__*/React.createElement(Text, _extends({
    pl: "16px",
    mt: "20px",
    mb: "5px",
    textStyle: "h2Emph"
  }, props), children);
};